import { NamePerson } from '../public-api';

export function getFullname(name: NamePerson): string {
  if (!name) {
    return '';
  }
  if (name.firstName && name.lastName) {
    return name.firstName + ' ' + name.lastName;
  }

  return name.name;
};
